import React from 'react';
import ContestLanding from '../common/ContestLanding';
import Dashboard from './ContestDashboard';
import $ from 'jquery';
import Monitor from './ContestMonitor';
import HmAjax from '../../util/HmAjax';
import HmEventRegistry from '../../model/HmEventRegistry';

const contestDashboardView = "contestDashboardView";
const contestMonitorView = "contestMonitorView";
class ContestHome extends ContestLanding {
  constructor(props) {
    super(props);
    this.state = {
      topicSubView:contestDashboardView,
      dashboardDataLoaded:true,
      monitorDataLoaded:true,
      monitorData:null,
      monitor_available:false,
      alreadywatched:false,
      dataLoaded:false,
      data:null
    };
    this.dashboardDropDownKey = "homeDropdown";
    this.topicPointClick =this.topicPointClick.bind(this);
    this.hidePromptWindow = this.hidePromptWindow.bind(this);
    this.setChild(this,"CONTEST");
  }

  componentDidMount(){
    super.componentDidMount();
    let alreadywatched  = this.getAttribute("contesthomevisited") || false;
    this.setState({alreadywatched:alreadywatched});
    //Eligible for last accessView
    this.setLastAccessView();
    //this.checkMonitorStatus();
  }

  checkMonitorStatus(){
      let me = this;

      let success = (response) => {
        if(response && response.msg == "scheduler_running"){
        //Show monitor tab
        me.setState({monitor_available:true})
        HmEventRegistry.fireEvent("INITIATE_GA_EVENT");
      }else if(response && response.msg == "scheduler_not_running"){
        me.setState({monitor_available:false})
      }
      }

      let failure = (err) => {
        console.error("Error occurred while getting Monitor Status : ", err);
      }

      new HmAjax(this.getUrlFor("MONITOR_SCHEDULER_STATUS")).get(success, failure);
  }

  regTab(){
    window.location.href="/registration"
  }

  resoureTab(){
    window.location.href="/trail"
  }


  hidePromptWindow(){
    this.setState({alreadywatched:true})

    if(!this.getAttribute("contesthomevisited")){
      try{
        this.setAttribute("contesthomevisited",true);	
      }catch(e){}
    }
  }


  topicPointClick(event){
    var target = event.currentTarget;
    $(".hometopmenu").removeClass("selected");
    $(target).addClass("selected");
  
    if($(target).hasClass("allTopics")){
      this.setState({topicSubView:contestDashboardView});
  
    }else if($(target).hasClass("pointssystem")){				
      this.setState({topicSubView:contestMonitorView});
    }
  
  }

  
  dahboardTab(){
    if(this.state.dashboardDataLoaded == true){
      return(
        <div className="allTopics hometopmenu selected" data-ga="Registration details tab" onClick={this.topicPointClick}>
        {this.rb("contest.dashboardtab")} 
        </div>
        );
      }
    }

    getMonitorStatus = () => {
      let currContestHost = this.getContestHost();
      let allowContestHost = window.monitor_avail_contest || [];
      let showMonitor = false;
      if(allowContestHost.length>0){
        allowContestHost.map((contest)=>{
          if(currContestHost.indexOf(contest)>-1){
            //console.warn("monitorTab in",currContestHost, " : ",contest, " : => ",currContestHost.indexOf(contest)>-1);
            showMonitor = true;
          }
        })
      }
      //console.warn("monitorTab out",currContestHost, " : ",allowContestHost);
      return showMonitor;
    }

    monitorTab = () => {
      let availHost = this.getMonitorStatus();
      //console.warn("monitorTab ",availHost, " avail : ",window.monitor_available , " data : ",this.state.monitorDataLoaded);
     
      if(window.monitor_available && availHost && this.state.monitorDataLoaded == true){
        return(
        <div className="pointssystem hometopmenu" data-ga="Contest Status tab" onClick={this.topicPointClick}>
        {this.rb("contest.monitortab")} 
        </div>
        );
      }
    }

    render() {
      let me=this;

       if(this.state.alreadywatched){
        return super.render(
          <div id="cont_reg" className="HomeComponent">
          {
            (()=>{
              return(
              <div className="topicspointsheader">
  
              {this.dahboardTab()}
  
              {this.monitorTab()}
  
              </div> 
              )
          })()
        }

            {
              (()=>{
              if(this.state.topicSubView === contestDashboardView){
               return(
                <div className="dashboard-content">
                <Dashboard contest_host={this.getSelectedContestGroup()}></Dashboard>
              </div>
               )
            }else if(this.state.topicSubView === contestMonitorView){
              return(
                <div className="dashboard-content">
               <Monitor data={this.state.monitorData} running={this.state.monitor_available} contestGrpId ={this.getSelectedContestGroup()}/>
              </div>
               )
            }
          
          } )()
          }
            </div>
          
        )
       }else{
        return super.render(
          <div className="HomeComponent mt-40" id="contesthome">

        <div className="gotit">
            <div className="text-left">
            <div className="close" data-ga="View Dashboard - Close" onClick={this.hidePromptWindow}> 
              <span><i className="material-icons">close</i></span>
            </div>
              
            </div>

        </div>

            <div className="clearfix"></div>
             <div className="cont">
             <h1>{this.rb("welcome.RIPMWC.year")} </h1> 
            
            <div className="browse" data-ga="Home - Registered student button" onClick={this.regTab} >{this.rb("contest.regbtn")}</div>
            
        </div>

      </div>
      )
       }
  }

}

export default ContestHome;




// WEBPACK FOOTER //
// ./src/views/contest/ContestHome.js